import {TeamI18n} from '@/locales/base.message.locales';

export const team: TeamI18n = {
  dialog: {
    destroy_team: 'Destroy team',
    sure_to_destroy: 'You\'re sure to destroy this team?',
  },
  tooltip: {
    destroy: 'Delete team',
    invite: 'Invite',
    edit: 'Edit team'
  },
  messages: {
    exit: {
      failed: 'Failed to exit from this team',
      success: 'You exited from this team'
    },
    create: {
      failed: 'Failed to create your team',
      success: 'Team created with success',
    },
    destroy: {
      failed: 'Failed to remove your team',
      success: 'Team deleted with success',
    },
    edit: {
      failed: 'Failed to edit your team',
      success: 'Team Edited with success',
    }
  },
  title: 'Team | Teams',
  invitations: 'Team Invitations',
  actions: {
    create: 'Create Team',
    destroy: 'Remove Team',
    edit: 'Edit Team',
    invite: 'Send Invitation | Send Invitations',
    invite_users: 'Invite Users',
    exit: 'Exit from this team',
    request_participation: 'Request participation',
    cancel_invite: 'Cancel Invite',
  },
  labels: {
    full_members: '{members} Members',
    open_member_slots: '{members} Members - {slots} open slots',
    leader: 'Captain',
    name: 'Team Name',
    banner_input: 'Team banner image',
    members_subtitle: 'Use the filters to find the ideal people for your team.',
    country_filter_title: 'Filter by Country',
    skills_filter_title: 'Filter by skills',
    countr_filter_select: 'Select country',
    users_empty: 'No users found to invite',
    select_users: 'Select users to invite to your team',
    search_users: 'Find members for my team',
  },
  buttons: {
    members: 'Members',
    pendent_invitations: 'Pendent Invitations',
    search: 'Search',
  },
  invites: {
    empty: 'You have no invitation to have the filter selected',
    text: 'This section will display all invitations from teams you have received and / or sent. to send an invitation to a team, first and you must be participating in a challenge, then choose one of the existing teams and send a request to be part of the team',
    messages: {
      invited: {
        accepted: 'Invitation accepted',
        pending: 'Invitation awaiting response',
        rejected: 'Invitation refused',
        canceled: 'Invitation canceled',
        removed: 'Invitation removed'
      },
      requested: {
        accepted: 'Request accepted',
        canceled: 'Request canceled',
        pending: 'Request awaiting response',
        rejected: 'Request rejected',
        removed: 'Request removed'
      }
    },
    challenge_name: 'Challenge: {name}',
    filter: {
      mode: 'Type',
      status: 'Status'
    },
    mode: {
      invited: 'Invited',
      requested: 'Requested'
    },
    status: {
      accepted: 'Accepted',
      pending: 'Pending',
      refused: 'Refused',
      canceled: 'Canceled',
      rejected: 'Rejected',
      removed: 'Removed'
    }
  }
};
